import Proxy from './Proxy';

class RmsDamdangProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('api/rms-damdang', parameters);
  }


}

export default RmsDamdangProxy;
